import { useQuery } from "@tanstack/react-query";
import { fetchEmailTemplatePreview, fetchEmailTemplates } from "../api/emailTemplatesApi";

const QUERY_KEY = ["email-templates"];

export const useEmailTemplatesQuery = () => {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: fetchEmailTemplates,
  });
};

export const useEmailTemplatePreviewQuery = (id: string | null) => {
  return useQuery({
    queryKey: [...QUERY_KEY, "preview", id],
    queryFn: () => fetchEmailTemplatePreview(id!),
    enabled: !!id,
  });
};
